// @flow

import React from "react";
import classNames from "classnames";
import { View } from "@components";

type Props = $Exact<{
  label: string,
  options: {
    icon?: string,
    wrapperClassName?: string,
    iconClassName?: string,
    labelClassName?: string,
  },
}>;

const DescriptionWidget = ({ options, label }: Props) => (
  // position absolute is needed so DescriptionWidget doesn't push other fields (it can have more height than other widgets)
  <View position="relative">
    <div className={classNames("schema-form-widget-description-widget", options.wrapperClassName)}>
      {options.icon && (
        <span className={classNames("material-icons", options.iconClassName)}>{options.icon}</span>
      )}
      <span className={classNames("fs-14", options.labelClassName)}>{label}</span>
    </div>
  </View>
);

export default DescriptionWidget;
